import React from 'react';

class MiscPopup extends React.Component {

    constructor(props) {
        super(props);
        this.showPopup = this.showPopup.bind(this);
        this.hidePopup = this.hidePopup.bind(this);
    }

    state = {
        showPopup: false,
    }

    showPopup() {
        this.setState({ showPopup: true });
    }

    hidePopup() {
        this.setState({ showPopup: false });
    }

    render() {

        let popup = {
            position: "absolute",
            zIndex: 99999,
            padding: "10px",
            background: "#f5f5f5",
            border: "1px solid #ccc",
            MozBorderRadius: "20px",
            WebkitBorderRadius: "20px",
            margin: "0px",
            WebkitBoxShadow: "0px 0px 5px 0px rgba(164, 164, 164, 1)",
            boxShadow: "0px 0px 5px 0px rgba(164, 164, 164, 1)",
        }


        if (this.state.showPopup) {
            return (
                <>
                    <span onMouseLeave={this.hidePopup} className="d-inline-block" style={{ "color": "red", "cursor": "pointer" }}>&nbsp;<i className="fas fa-info"></i></span>
                    <div style={popup}>
                        {this.props.message}
                    </div>
                </>
            );
        } else {
            return (
                <span onMouseEnter={this.showPopup} className="d-inline-block" style={{ "color": "red", "cursor": "pointer" }}>&nbsp;<i className="fas fa-info"></i></span>
            );
        }
    }
}

export default MiscPopup;